import React from "react";
import { Weather } from "../../types";

const ClubWeather = ({ weather }: { weather: Weather }) => (
	<div className="clubWeather" data-weather={weather.type.toLowerCase()}>
		<div className="weatherIcon"></div>
		<div className="weatherMeta">
			<span className="maxTemperature">{weather.max}&deg;</span>
			<span className="minTemperature">/ {weather.min}&deg;</span>
			<span className="weatherDescription">{weather.description}</span>
		</div>
	</div>
);

export default ClubWeather;
